import { useEffect, useRef } from "react";

// Verborgen toetsencode. Het dashboard hangt fulltime aan een Raspberry Pi
// zonder toetsenbord-URL-balk, dus het animatielab is anders niet te
// bereiken. Met een toetsenbord erin typ je het woord gewoon in:
//
//   "ja"  op het dashboard -> naar het animatielab
//   "nee" in het lab       -> terug naar het dashboard
//
// Er staat nergens op het scherm dat dit kan: dat is precies de bedoeling.
// Je moet het weten, de tv verklapt niets.
//
// De letters moeten binnen defaultWindowMs achter elkaar getypt worden. Blijft het
// daarna stil, dan is de code vergeten - zodat een losse "j" van iets anders
// niet blijft hangen tot er ooit een "a" langskomt.

const defaultWindowMs = 3000;

export function useSecretCode(codes, { window: windowMs = defaultWindowMs } = {}) {
  // De handlers in een ref, dan hoeft de listener niet opnieuw te binden bij
  // elke render.
  const codesRef = useRef(codes);
  codesRef.current = codes;

  useEffect(() => {
    let buffer = "";
    let timer = null;

    const forget = () => {
      buffer = "";
      timer = null;
    };

    const onKey = (event) => {
      const tag = event.target?.tagName;
      if (tag === "INPUT" || tag === "TEXTAREA" || event.target?.isContentEditable) return;
      if (event.metaKey || event.ctrlKey || event.altKey) return;
      if (event.key.length !== 1) return;

      const entries = Object.entries(codesRef.current || {});
      const longest = entries.reduce((max, [code]) => Math.max(max, code.length), 0);
      if (!longest) return;

      buffer = (buffer + event.key.toLowerCase()).slice(-longest);

      clearTimeout(timer);
      timer = setTimeout(forget, windowMs);

      // Langste code eerst: "nee" mag niet door een kortere "ee" worden
      // afgesnoept als die er ooit bij komt.
      const hit = entries
        .sort((a, b) => b[0].length - a[0].length)
        .find(([code]) => buffer.endsWith(code.toLowerCase()));

      if (hit) {
        clearTimeout(timer);
        forget();
        hit[1]();
      }
    };

    window.addEventListener("keydown", onKey);
    return () => {
      window.removeEventListener("keydown", onKey);
      clearTimeout(timer);
    };
  }, [windowMs]);
}
